import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { Sentry } from 'utils/raven';
import Container from 'base-ui/dist/Container';
import CustomError from 'base-ui/dist/CustomError';
import PageWrapper from 'base-ui/dist/PageWrapper';
import { intl } from 'components/LocaleProvider';
import Sidebar from 'components/Sidebar';
import LatestPosts from './LatestPosts';
import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const SEO = dynamic(() => import('components/SEO'));

const Error404 = ({ posts }) => {
  Sentry.addBreadcrumb({
    category: 'screens/Error/404',
    message: 'Render error page with code: 404',
    level: Sentry.Severity.Debug,
  });

  const title = intl.formatMessage(messages.notFound);
  return (
    <PageWrapper config={{ title: intl.formatMessage(messages.notFoundTitle) }} className="align-center">
      <SEO
        resource={{
          metas: {
            title,
            robots: 'noindex,follow',
            'og:title': title,
            'og:locale': publicRuntimeConfig.APP_LOCALE,
            'og:site_name': publicRuntimeConfig.blogname,
          }
        }}
      />
      <Container fluid wrap>
        <CustomError
          title={intl.formatMessage(messages.notFound)}
          description={intl.formatMessage(messages.notFoundDesc)}
          button={{
            to: '/',
            bgColor: 'secondary',
            borderColor: 'secondary',
            textColor: 'white',
            label: intl.formatMessage(messages.homeBtn),
            routerStrategy: 'none'
          }}
          imageColor="secondary"
        >
          <LatestPosts posts={posts} />
        </CustomError>
        <Sidebar sidebarSlug="footer-page" />
      </Container>
    </PageWrapper>
  );
};

Error404.propTypes = {
  posts: PropTypes.array,
};

export default Error404;
